import PositionPref from "../../enums/position-pref";
import FootballState from "../../state/football-state";
import { getYardsGained } from "../../utils/context-utils";
import Pref from "./position-pref";

export default class FumbleForcedByPositionPref extends Pref {
    constructor(play, fragment) {
        super(play, fragment);
    }

    resolve() {
        const { associatedState, receivedAt } =
            this.play.getPreviousFragment(this.fragment) || {};
        const isCompletePass = associatedState === FootballState.PassComplete;
        const yardsGained = getYardsGained(
            this.play.contextSnapshot,
            receivedAt
        );

        if (isCompletePass && yardsGained < 10) {
            return PositionPref.PASS_TACKLE;
        }
        if (this.play.historyContains(FootballState.Rush)) {
            return PositionPref.RUSH_TACKLE;
        }
        return [];
    }
}
